import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import config from "./config/config";
import { applyPortalTelemetryTags } from "./utils/app-insights.helper";

const reactPlugin: ReactPlugin = new ReactPlugin();
let appInsights: ApplicationInsights | null = null;

export const telemetryService = () => {
  const initialize = () => {
    const browserHistory = createBrowserHistory();
    if (config.applicationInsightsConnectionString) {
      appInsights = new ApplicationInsights({
        config: {
          connectionString: config.applicationInsightsConnectionString,
          extensions: [reactPlugin],
          extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory },
          },
          autoTrackPageVisitTime: true,
          enableAutoRouteTracking: true,
        },
      });
      appInsights.loadAppInsights();
      appInsights.addTelemetryInitializer(applyPortalTelemetryTags);
    }
  };
  return { appInsights, initialize };
};

export const getReactPlugin = () => reactPlugin;
export const getAppInsights = () => appInsights;
